import * as Types from '../../../__generated__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ResendMemberInvitationOnWorkspaceSettingsMembersPageMutation = { __typename?: 'RootMutationType', resendMemberInvitation?: { __typename?: 'MemberInvitationResult', memberInvitation?: { __typename?: 'MemberInvitation', id: string, email?: string | null, invitedAt?: any | null, isExpired?: boolean | null, role?: string | null } | null, userErrors?: Array<{ __typename?: 'UserError', field: string, message: string } | null> | null } | null };


export const ResendMemberInvitationOnWorkspaceSettingsMembersPageDocument = gql`
    mutation resendMemberInvitationOnWorkspaceSettingsMembersPage($id: ID!) {
  resendMemberInvitation(id: $id) {
    memberInvitation {
      id
      email
      invitedAt
      isExpired
      role
    }
    userErrors {
      field
      message
    }
  }
}
    `;
export type ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationFn = Apollo.MutationFunction<ResendMemberInvitationOnWorkspaceSettingsMembersPageMutation, ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>;

/**
 * __useResendMemberInvitationOnWorkspaceSettingsMembersPageMutation__
 *
 * To run a mutation, you first call `useResendMemberInvitationOnWorkspaceSettingsMembersPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMemberInvitationOnWorkspaceSettingsMembersPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMemberInvitationOnWorkspaceSettingsMembersPageMutation, { data, loading, error }] = useResendMemberInvitationOnWorkspaceSettingsMembersPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendMemberInvitationOnWorkspaceSettingsMembersPageMutation(baseOptions?: Apollo.MutationHookOptions<ResendMemberInvitationOnWorkspaceSettingsMembersPageMutation, ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendMemberInvitationOnWorkspaceSettingsMembersPageMutation, ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>(ResendMemberInvitationOnWorkspaceSettingsMembersPageDocument, options);
      }
export type ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationHookResult = ReturnType<typeof useResendMemberInvitationOnWorkspaceSettingsMembersPageMutation>;
export type ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationResult = Apollo.MutationResult<ResendMemberInvitationOnWorkspaceSettingsMembersPageMutation>;
export type ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationOptions = Apollo.BaseMutationOptions<ResendMemberInvitationOnWorkspaceSettingsMembersPageMutation, ResendMemberInvitationOnWorkspaceSettingsMembersPageMutationVariables>;